// Keep the host used to create OAuth state and PKCE identical to the callback host.
const APP_ORIGINS = {
  'dev.tegratauto.com': 'https://app-dev.tegratauto.com',
  'app-dev.tegratauto.com': 'https://app-dev.tegratauto.com',
  'tegratauto.com': 'https://app.tegratauto.com',
  'www.tegratauto.com': 'https://app.tegratauto.com',
  'app.tegratauto.com': 'https://app.tegratauto.com',
};
const PUBLIC_PATHS = new Set(['/', '/support', '/privacy', '/sms-consent']);

export function getAppOrigin(hostname) {
  return Object.prototype.hasOwnProperty.call(APP_ORIGINS, hostname) ? APP_ORIGINS[hostname] : null;
}

export function getCanonicalAppRedirect(location) {
  const origin = getAppOrigin(location.hostname);
  if (!origin || location.origin === origin) return null;
  const path = location.pathname.replace(/\/+$/, '') || '/';
  if (PUBLIC_PATHS.has(path)) return null;
  // A callback already on the wrong origin cannot recover its PKCE verifier.
  // Start fresh on the app host instead of forwarding an unusable OAuth code.
  if (path === '/auth/callback') return `${origin}/dashboard`;
  return `${origin}${location.pathname}${location.search}${location.hash}`;
}

export function getAppleOAuthConfig(hostname) {
  const origin = getAppOrigin(hostname);
  if (!origin) return undefined;
  const isDev = origin === 'https://app-dev.tegratauto.com';
  const domain = process.env.REACT_APP_COGNITO_DOMAIN || (isDev ? undefined : 'auth.tegratauto.com');
  if (!domain || (isDev && domain === 'auth.tegratauto.com')) return undefined;
  return {
    domain,
    scopes: ['openid', 'email', 'aws.cognito.signin.user.admin'],
    redirectSignIn: [`${origin}/auth/callback`],
    redirectSignOut: [`${origin}/dashboard`],
    responseType: 'code',
    providers: ['Apple'],
  };
}

export function startOnCanonicalApp(location, start) {
  const destination = getCanonicalAppRedirect(location);
  if (destination) location.replace(destination);
  else start();
}
